export const toTasks = () => "/zadania";

export const toTask = (id) => `/zadania/${id}`;

export const toAuthor = () => "/autor";
